if (!customElements.get('sheworks-archive')) {
  customElements.define('sheworks-archive', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController(); this.grid = this.querySelector('[data-archive-grid]');
      this.more = this.querySelector('[data-archive-more]'); this.status = this.querySelector('[data-archive-status]');
      this.limit = 24; this.entries = Array.from(this.grid.querySelectorAll('[data-archive-entry]'));
      this.click = () => { this.limit += 24; this.render(true); };
      this.more.addEventListener('click', this.click); this.render(); this.collect();
    }
    disconnectedCallback() { this.controller?.abort(); this.more?.removeEventListener('click', this.click); }
    render(announce = false) {
      this.entries.sort((a,b) => Number(a.dataset.order)-Number(b.dataset.order) || a.dataset.entryId.localeCompare(b.dataset.entryId));
      const fragment = document.createDocumentFragment();
      this.entries.forEach((entry,index) => { entry.hidden=index>=this.limit; fragment.append(entry); });
      this.grid.append(fragment); const empty=this.querySelector('[data-archive-empty]'); if(empty) empty.hidden=this.entries.length>0; this.more.hidden=this.entries.length<=this.limit;
      if (announce) this.status.textContent=`Showing ${Math.min(this.limit,this.entries.length)} of ${this.entries.length} photographs`;
    }
    async collect() {
      const first=new URL(location.href); first.searchParams.set(this.querySelector('[data-archive-pagination]').dataset.pageParam || 'page','1');
      let next=this.querySelector('[data-archive-previous]') ? first.href : this.querySelector('[data-archive-next]')?.href;
      const seen=new Set(); const ids=new Set(this.entries.map(e=>e.dataset.entryId));
      try {
        while(next && !seen.has(next)) {
          seen.add(next); const url=new URL(next,location.origin);
          if(url.origin!==location.origin) throw new Error('Invalid archive origin');
          url.searchParams.set('section_id',this.dataset.section);
          const response=await fetch(url,{signal:this.controller.signal,credentials:'same-origin'});
          if(!response.ok) throw new Error('Archive request failed');
          const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
          const archive=parsed.querySelector('sheworks-archive'); if(!archive) throw new Error('Archive section missing');
          archive.querySelectorAll('[data-archive-entry]').forEach(entry=>{if(!ids.has(entry.dataset.entryId)){ids.add(entry.dataset.entryId);entry.hidden=true;this.entries.push(entry);}});
          next=archive.querySelector('[data-archive-next]')?.href;
        }
        if (!this.isConnected) return;
        this.render(); this.querySelector('[data-archive-pagination]').hidden=true;
      } catch(error) {
        if(error.name==='AbortError') return;
        if(this.isConnected){this.render();this.status.textContent='More photographs are available through the archive page links.';}
      }
    }
  });
}
